/**
 * Origin of a conversion request per developer-api.md §1.
 *
 * `website` — classic browser uploads through the public web UI.
 * `api_key` — public API call authenticated by an ApiKey.
 *
 * Wire format: lowercase matches the Kotlin `WorkflowSource` enum
 * (see `springboot-shared-library/enforcement/WorkflowSource.kt`).
 */
export const WorkflowSource = {
    WEBSITE: 'website',
    API_KEY: 'api_key',
};
